let apiMode = 'build'; //接口环境
let apiUrl = ''; //主接口
let imgUrl = '';//图片途径
let resourceUrl = '';//资源路径
let deviceType = 0; //设备环境 0浏览器环境 1支付宝环境 2微信环境 3APP
let orderSource = 0; //订单来源 4浏览器 6支付宝生活号 9微信生活号
let payChannels = {}; //可使用的支付渠道
var sweixin = null; //微信分享信息

let url_hostname = window.location.hostname;
if( /carowner.dafang24.com/.test(url_hostname) ){ apiMode = 'build' } //防止线上代码运行开发/测试环境的代码
switch (apiMode) {
  case "dev": //开发环境
    apiUrl = "http://192.168.0.252:1009/";
    imgUrl = "http://192.168.0.252:1000/";
    resourceUrl = "http://192.168.0.252:1016/";
    break;
  case "SIT": // SIT测试
    apiUrl = "http://carownerapi.sit.dafang24.com/";
    imgUrl = "https://cms.dafang24.com/";
    resourceUrl = "https://cms.dafang24.com/";
    break;
  case "build": // 发布环境
    apiUrl = "https://api.new.dafang24.com:441/";
    imgUrl = "https://cms.dafang24.com/";
    resourceUrl = "https://cms.dafang24.com/";
    break;
}

//判断支付环境
let userAgent = navigator.userAgent;
if (/MicroMessenger/.test(userAgent)) { //微信客户端
  deviceType = 2;
  orderSource = 9;
  wx.miniProgram.getEnv(res => {
    if (res.miniprogram) {
      deviceType = 2.5;
      console.log("在小程序里");
    } else {
      console.log("不在小程序里");
    }
  })
}
else if (/AlipayClient/.test(userAgent)) { //支付宝客户端
  deviceType = 1;
  orderSource = 6;
}
else if (/Html5Plus/.test(userAgent)) { //APP客户端
  deviceType = 3;
  if(/Android/.test(userAgent) || /Adr/.test(userAgent)){ //安卓设备
    orderSource = 16;
  }
  if(!!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)){ //苹果设备
    orderSource = 17;
  }
}
else if(/DFZCAPPAndroid/.test(userAgent) || /DFZCAPPiOS/.test(userAgent)){
   if(/DFZCAPPAndroid/.test(userAgent)){
     orderSource = 16;
   }
   if(/DFZCAPPiOS/.test(userAgent)){
     orderSource = 17;
   }
}
else { //其他浏览器
  deviceType = 0;
  orderSource = 4;
}
document.addEventListener('plusready', function () {
  plus.payment.getChannels(function (channels) {
    for (var i in channels) {
      var channel = channels[i];
      payChannels[channel.id] = channel;
    }
    console.log(JSON.stringify(payChannels));
  }, function (e) {
    console.log("获取支付失败")
  });
  plus.share.getServices(function(s){
    let shares={};
    for(var i in s){
      var t=s[i];
      shares[t.id]=t;
    }
    sweixin=shares['weixin'];
  });
});

export {
  apiMode,
  apiUrl,
  imgUrl,
  resourceUrl,
  deviceType,
  orderSource,
  payChannels,
  sweixin,
}



// WEBPACK FOOTER //
// ./src/utils/env.js